// material-ui
import { useTheme } from '@mui/material/styles';
import { Container, Grid, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// project imports
import { gridSpacing } from 'views/pages/common/constant';
import { MainTitle } from 'views/pages/common/MainTitle';
import { MotionDiv } from 'views/pages/common/MotionDiv';
import { MainAction } from 'views/pages/common/MainAction';
import useStyles from './screeningStyles';

const whyChooseUs = [
	`Motto - "Every child deserves a full life"`,
	`Team - seasoned Therapists, Neuroscientists & Doctors`,
	`Therapy - guided by cutting edge brain research`,
	`Data - studied by designated Neuroscientists`,
	`Sessions - by Therapists who are special needs mothers' first`
];

const ScreeningContent = () => {
	const theme = useTheme();
	const classes = useStyles();
	return (
		<Container disableGutters={true} className={classes.bgImage}>
			<Grid
				container
				alignItems='center'
				justifyContent='space-between'
				sx={{ mt: { xs: 8, sm: 4, md: 12 }, mb: { xs: 2.5, md: 10 }, ml: { xs: 2 } }}>
				<Grid item md={6} lg={6}></Grid>
				<Grid item xs={12} md={6} lg={6}>
					<Grid
						spacing={gridSpacing}
						sx={{
							pr: 0,
							textAlign: 'justify',
							[theme.breakpoints.down('lg')]: { pr: 0, textAlign: 'center' }
						}}>
						<Grid item xs={12} style={{ pr: 0 }}>
							<MainTitle title='Early detection is CRITICAL'></MainTitle>
						</Grid>
						<Grid item xs={12} sx={{ mt: { xs: 3, md: 2 } }}>
							<MotionDiv delay='0.2'>
								<Typography
									variant='h4'
									component='div'
									color='inherit'
									sx={{ fontSize: { xs: '1rem', md: '1.125rem' }, fontWeight: 400, lineHeight: 1.4 }}>
									The American Academy of Pediatrics recommends screening all children for specific
									developmental conditions @ 18 and 24-month wellness checkup.
								</Typography>
							</MotionDiv>
						</Grid>
						<Grid item xs={12}>
							<MainAction full={true} text='Schedule Screen'></MainAction>
						</Grid>
						<Grid item xs={12} sx={{ mt: { xs: 3, md: 2 } }}>
							<MotionDiv delay='0.2'>
								<Typography
									variant='h4'
									component='div'
									color='inherit'
									sx={{ fontSize: { xs: '1rem', md: '1.125rem' }, fontWeight: 400, lineHeight: 1.4 }}>
									Research has proven that brain’s ability to change in response to experiences is
									highest in the early development years of a child.
								</Typography>
							</MotionDiv>
						</Grid>
						<Grid item xs={12} sx={{ mt: { xs: 3, md: 2 } }}>
							<MotionDiv delay='0.2'>
								<Typography
									variant='h4'
									component='div'
									color='inherit'
									sx={{ fontSize: { xs: '1rem', md: '1.125rem' }, fontWeight: 400, lineHeight: 1.4 }}>
									Delayed diagnosis not only leads to parental stress but also late intervention
									resulting in the missed opportunity to leverage critical first five years of child’s
									development.
								</Typography>
							</MotionDiv>
						</Grid>
						<Grid item xs={12}>
							<Grid container>
								<Grid item xs={4}>
									<MainAction
										full={false}
										icon={<InfoOutlinedIcon />}
										text='Autism Screen'
										color='orange'></MainAction>
								</Grid>
								<Grid item xs={4}>
									<MainAction
										full={false}
										icon={<InfoOutlinedIcon />}
										text='Skill Deficit Screen'
										color='orange'></MainAction>
								</Grid>
								<Grid item xs={4}>
									<MainAction
										full={false}
										icon={<InfoOutlinedIcon />}
										text='Functional Behavior Screen'
										color='orange'></MainAction>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Container>
	);
};

export default ScreeningContent;
